import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web
import { combineReducers } from '@reduxjs/toolkit';
import loader from './loading.slice';
import partiallyLoader from './partiallyLoading.slice';
import sideMenu from './sideMenu.slice';
import lang from './lang.slice';
import profile from './profile.slice';
import ip from './ip.slice';
import formSlice from './event.slice';
import enumsSlice from './enums.slice';
import appointmentCount from './appointmentCount.slice';
import tenant from './activeTenant.slice';
import zohoIntegrationId from './zohoIntegrationId.slice';
import googleData from './googleData.slice';

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['loader', 'partiallyLoader', 'sideMenu', 'lang', 'profile', 'ip', 'formSlice', 'enumsSlice', 'appointmentCount', 'tenant', 'zohoIntegrationId'], // Only persist these reducers
};

const rootReducer = combineReducers({
  loader,
  partiallyLoader,
  sideMenu,
  lang,
  profile,
  ip,
  formSlice,
  enumsSlice,
  appointmentCount,
  tenant,
  zohoIntegrationId,
  googleData,
  });

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }),
});

export const persistor = persistStore(store);

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
